<template>
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="column-center" v-if="info">
				<h3>대리 신청</h3>
				
				<!-- 프로세스 플로우 (Process Flow) -->
				<div style="margin-bottom: 30px; padding: 30px 20px; background: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);" v-if="info">
					<el-steps :active="activeStep" align-center finish-status="success">
						<el-step v-for="(step, index) in steps" :key="index" :title="step.title" :description="step.description"></el-step>
					</el-steps>
				</div>

				<el-descriptions title="" direction="vertical" :column="isMobile?2:4" border>
				  <el-descriptions-item  label="신청 대리 유형">
					  <div v-if="info.agency_type == '1'" style="color:#409eff;">배송대행 신청</div>
					  <div v-else-if="info.agency_type == '2'" style="color:#67c23a;">구매대행 신청</div>	
				  </el-descriptions-item>
				  <el-descriptions-item label="배송방법 선택">
					  <div v-if="info.delivery_center_code == 'CN_SHIP'" >해상</div>
					  <div v-else-if="info.delivery_center_code == 'CN_AIR'" >항공</div>
					  <div v-else-if="info.delivery_center_code == 'CN_LCL'" >LCL화물</div>
				  </el-descriptions-item>
				  <el-descriptions-item label="통관방법 선택">
					  <div v-if="info.customs_type == '1'" style="color:#409eff;">간이통관</div>
					  <div v-else-if="info.customs_type == '2'" style="color:#67c23a;">목록통관</div>
					  <div v-else-if="info.customs_type == '3'" style="color:#67c23a;">사업자통관</div>	
				  </el-descriptions-item>
				  <el-descriptions-item label="회원명">{{info.nickname}}</el-descriptions-item>
				  <el-descriptions-item label="상품 총 금액">{{info.total_amount}}</el-descriptions-item>
				  
				   <el-descriptions-item label="수취인명">{{info.address?.consignee}}</el-descriptions-item>
				   <el-descriptions-item label="영문 수취인명">{{info.address?.en_consignee}}</el-descriptions-item>
				   <el-descriptions-item label="우편번호">{{info.address?.zipcode}}</el-descriptions-item>
				   <el-descriptions-item label="핸드폰">{{info.address?.mobile}}</el-descriptions-item>
				   <el-descriptions-item label="개인통관고유부호">{{info.address?.customs_info}}</el-descriptions-item>
				   <el-descriptions-item label="주소" :span="2">{{info.address?.address}} {{info.address?.detailed_address}}</el-descriptions-item>
				  
				   <el-descriptions-item label="국내 택배사 요청사항">{{info.express_demand}}</el-descriptions-item>
				   <el-descriptions-item label="제거">{{info.remove}}</el-descriptions-item>
				  <el-descriptions-item label="검수">{{info.check_level}}</el-descriptions-item>
				  <el-descriptions-item label="포장">{{info.packing_level}}</el-descriptions-item>
				  <el-descriptions-item label="포장">{{info.add_packing}}</el-descriptions-item>
				  <el-descriptions-item label="기타">{{info.template_info}}</el-descriptions-item>
				  <el-descriptions-item label="기타">{{info.customs}}</el-descriptions-item>
				  <el-descriptions-item label="결제 옵션">{{info.pay_service}}</el-descriptions-item>
				  <el-descriptions-item label="선/착불 구분">{{info.service_cargo_type}}</el-descriptions-item>
				  <el-descriptions-item label="FTA 세율 적용 여부">{{info.service_fta_type}}</el-descriptions-item>
				  <el-descriptions-item label="관부가세 안내">{{info.service_tariff_notify}}</el-descriptions-item>
					<el-descriptions-item label="검토 상태">
						<div v-if="info.audit_status == '0'" style="color:#409eff;">검토 대기</div>
						<div v-else-if="info.audit_status == '1'" style="color:#67c23a;">통과</div>
						<div v-else-if="info.audit_status == '2'" style="color:#f56c6c;">거절</div>	
					</el-descriptions-item>
				  <!-- <el-descriptions-item label="备注">
				    <el-tag size="small">学校</el-tag>
				  </el-descriptions-item> -->
				</el-descriptions>
				
				<div v-for="(item,index) in info.goods" :key="index" style="margin:30px 0; background: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);">
					<div style="font-size: 16px; font-weight: bold; margin-bottom: 20px; text-align: center; color: #303133;">{{item.goods_name}}</div>
					
					<!-- 상품 개별 프로세스 플로우 (Goods Process Flow) -->
					<div style="padding: 10px 10px 30px 10px;">
						<el-steps :active="getGoodsActiveStep(item)" :finish-status="getGoodsStepStatus(item) === 'error' ? 'error' : 'success'" :process-status="getGoodsStepStatus(item) === 'error' ? 'error' : 'process'" align-center size="small">
							<el-step title="대기"></el-step>
							<el-step title="구매중"></el-step>
							<el-step title="도착"></el-step>
							<el-step title="입고"></el-step>
							<el-step title="포장중"></el-step>
							<el-step title="발송완료"></el-step>
						</el-steps>
					</div>

					<el-descriptions direction="vertical" :column="isMobile?2:4" border>
						<el-descriptions-item  label="상품 이미지" >
							<el-popover placement="right" trigger="hover" v-if="item.goods_image">
								<el-image 
									style="width: 200px; height: 200px" 
									:src="item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image" 
									fit="contain">
								</el-image>
								<el-image slot="reference"
									style="width: 80px; height: 80px; cursor: pointer;"
									:src="item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image"
									fit="cover">
								</el-image>	
							</el-popover>
						</el-descriptions-item>
						<el-descriptions-item  label="ID" >
							{{item.id}}
						</el-descriptions-item>
						<el-descriptions-item  label="상품 분류 ID">
							{{item.category_id}}
						</el-descriptions-item>
						<el-descriptions-item  label="상품명(영문)">
							{{item.goods_name}}
						</el-descriptions-item>
						<el-descriptions-item  label="상품 상태">
							<span style="color: #409EFF; font-weight: bold;">{{item.goods_status_text}}</span>
						</el-descriptions-item>
						<el-descriptions-item  label="택배 번호">
							{{item.tracking_no}}
						</el-descriptions-item>
						<el-descriptions-item  label="사이즈(중국어)">
							{{item.size}}
						</el-descriptions-item>
						<el-descriptions-item  label="주문 번호">
							{{item.order_no}}
						</el-descriptions-item>
						<el-descriptions-item  label="색상(중국어)">
							{{item.color}}
						</el-descriptions-item>
						<el-descriptions-item  label="단가">
							{{item.price}}
						</el-descriptions-item>
						<el-descriptions-item  label="수량">
							{{item.apply_quantity}}
						</el-descriptions-item>
						<el-descriptions-item  label="관리코드">
							{{item.product_code}}
						</el-descriptions-item>
						<el-descriptions-item  label="포장박스수량">
							{{item.box_count}}
						</el-descriptions-item>
						<el-descriptions-item  label="관리 코드">
							{{item.refer_code}}
						</el-descriptions-item>
						<el-descriptions-item  label="출고 메모">
							{{item.shipping_memo}}
						</el-descriptions-item>
						<el-descriptions-item  label="원산지작업(유료)">
							{{item.origin}}
						</el-descriptions-item>
						<el-descriptions-item  label="포장보완(유료)">
							{{item.package}}
						</el-descriptions-item>
						<el-descriptions-item  label="정밀검수(유료)">
							{{item.check}}
						</el-descriptions-item>
						<el-descriptions-item  label="상품 URL">
							{{item.url}}
						</el-descriptions-item>
						
					</el-descriptions>
				</div>
				
				
				<div class="content-bottom">
					<el-button @click="onOneList">글목록</el-button>
				</div>
				
			</div>
		</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		props: ['id'],
		data() {
			return {
				info:"",
				loading: true,
			};
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			},
			steps() {
				if (!this.info) return [];
				if (this.info.agency_type == '1') {
					// 배송대행 (Freight Forwarding)
					return [
						{ title: '신청접수', description: '신청서 작성 완료' },
						{ title: '입고대기', description: '센터 입고 대기중' },
						{ title: '입고완료', description: '센터 입고 완료' },
						{ title: '운임결제', description: '배송비 결제 대기' },
						{ title: '국제배송', description: '해외 배송 진행' },
						{ title: '배송완료', description: '수취 완료' }
					];
				} else if (this.info.agency_type == '2') {
					// 구매대행 (Procurement Agency)
					return [
						{ title: '신청접수', description: '신청서 작성 완료' },
						{ title: '상품결제', description: '상품 대금 결제' },
						{ title: '구매/입고', description: '구매 및 센터 입고' },
						{ title: '입고완료', description: '센터 입고 완료' },
						{ title: '운임결제', description: '배송비 결제 대기' },
						{ title: '국제배송', description: '해외 배송 진행' },
						{ title: '배송완료', description: '수취 완료' }
					];
				}
				return [];
			},
			activeStep() {
				if (!this.info) return 0;
				const { agency_type, audit_status, pay_status, status, status_name, inventory_status } = this.info;
				const currentStatus = Number(status) || 0;
				
				if (audit_status == '2') {
					return 0; // 거절 (Rejected)
				}
				
				// 6: 입고완료, 7: 입고보류, 22: 포장/무게측정
				const isStorageCompleted = [6, 7, 22].includes(currentStatus) || 
					(status_name && (status_name.includes('입고완료') || status_name.includes('일부입고'))) || 
					(inventory_status && (inventory_status.includes('입고완료') || inventory_status.includes('일부입고')));
				
				if (agency_type == '1') {
					// 배송대행 플로우 (총 6단계)
					if (audit_status == '0') return 0; // 신청접수
					
					if (currentStatus === 29) return 6; // 배송완료 (29)
					if (currentStatus >= 24 && currentStatus <= 28) return 4; // 국제배송
					if (currentStatus === 23) return 3; // 운임결제
					
					if (isStorageCompleted) return 2; // 입고완료
					return 1; // 입고대기 (1~5)
				} else if (agency_type == '2') {
					// 구매대행 플로우 (총 7단계)
					if (audit_status == '0') return 0; // 신청접수
					
					if (currentStatus === 29) return 7; // 배송완료 (29)
					if (currentStatus >= 24 && currentStatus <= 28) return 5; // 국제배송
					if (currentStatus === 23) return 4; // 운임결제
					
					if (isStorageCompleted) return 3; // 입고완료
					
					// 30: 결제대기(상품) 
					if (currentStatus === 30 || pay_status == '0') return 1; // 상품결제
					
					// 31: 결제완료(상품), 32: 구매완료, 1~5: 신청접수/부분입고 등
					if (currentStatus === 31 || currentStatus === 32 || (currentStatus > 0 && currentStatus <= 5)) return 2; // 구매/입고
					
					return 1; // 입고대기 전
				}
				return 0;
			}
		},	
		created() {
			this.getDetail()
		},
		methods: {
			getGoodsActiveStep(item) {
				const s = Number(item.goods_status) || 0;
				const text = item.goods_status_text || '';
				
				if (s >= 50 && s < 60) return 6; // 발송완료 (All steps complete)
				if (s === 40 || text.includes('포장')) return 4; // 포장중
				
				const isWarehoused = s === 35 || text.includes('입고완료') || text.includes('일부입고') || text === '입고';
				if (isWarehoused) return 3; // 입고
				
				if (s === 20 || s === 25 || s === 30 || text.includes('도착')) return 2; // 도착
				if (s === 15 || text.includes('구매')) return 1; // 구매중
				if (s <= 10) return 0; // 대기
				if (s === 60) return 0; // 종료
				return 0;
			},
			getGoodsStepStatus(item) {
				const s = Number(item.goods_status) || 0;
				if (s === 25 || s === 60) return 'error'; // 이상 or 종료
				return 'success';
			},
			getDetail(){
				this.loading = true
				request.post('/member/Agency/getAgencyDetail',
					{
						id:this.id,
					}
				).then(res => {
					this.loading = false
					console.log(res.data,"xiangqing")
					if(res.code ==1){
						this.info = res.data
					}			
				}).catch(() => {
					this.loading = false
				});
			},
			onOneList(){
				this.$router.push(`/agencyList`)
			},
		}
		
		
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}

	.content-bottom{
		padding:20px;
		display: flex;
		justify-content: end;
	}
	::v-deep th.el-descriptions-item__cell,::v-deep th.el-descriptions-item__label,::v-deep th.is-bordered-label{
		color:#333;
	}
	::v-deep .el-table__header th {
		color: #333; 
		font-size: 13px;
		font-weight: bold;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
</style>